import React from 'react'

import {
    Container,
    ContentTypografy,
    TittleTypografy,
    SubContentTypografy,
    ContentButton,
    Button,
    Image,
    ButtonSupport,
} from './styles'

import { Typography } from 'src/components'
import { Box } from 'src/components'

interface propsError {
    handleClose: any
    image: string
    title: string
    content: string
    button: string
    double: boolean
    contact?: string
}

const Index = ({
    handleClose,
    content,
    title,
    image,
    button,
    double,
    contact,
}: propsError) => {
    const buttons = () => {
        if (double) {
            return (
                <ContentButton>
                    <Button onClick={handleClose}>
                        <Typography
                            variant={'h2'}
                            fontSize={[
                                'xsmall',
                                'xsmall',
                                'xxxsmall',
                                'xxxsmall',
                            ]}
                            fontWeight={400}
                        >
                            {button}
                        </Typography>
                    </Button>
                </ContentButton>
            )
        } else {
            return (
                <ContentButton>
                    <Button onClick={handleClose}>
                        <Typography
                            variant={'h2'}
                            fontSize={[
                                'xsmall',
                                'xsmall',
                                'xxxsmall',
                                'xxxsmall',
                            ]}
                            fontWeight={400}
                        >
                            {button}
                        </Typography>
                    </Button>
                    <ButtonSupport
                        href={
                            'https://api.whatsapp.com/send?phone=573216068824'
                        }
                    >
                        <Typography
                            variant={'h2'}
                            fontSize={[
                                'xsmall',
                                'xsmall',
                                'xxxsmall',
                                'xxxsmall',
                            ]}
                            fontWeight={400}
                        >
                            {contact}
                        </Typography>
                    </ButtonSupport>
                </ContentButton>
            )
        }
    }
    return (
        <Container>
            <Box>
                <Image src={image} alt={title} />
            </Box>
            <ContentTypografy>
                <TittleTypografy>
                    <Typography
                        variant={'h1'}
                        fontSize={['xxlarge', 'xxlarge', 'titlle', 'titlle']}
                        fontWeight={300}
                    >
                        {title}
                    </Typography>
                </TittleTypografy>
                <SubContentTypografy>
                    <Typography
                        variant={'h2'}
                        fontSize={['xsmall', 'xsmall', 'xxsmall', 'xxsmall']}
                        fontWeight={400}
                    >
                        {content}
                    </Typography>
                </SubContentTypografy>
            </ContentTypografy>
            {buttons()}
        </Container>
    )
}

export default Index
